import React, { Component } from 'react';

import './BucketRollInfo.scss';

import { BUCKET_ROLL } from '../../../../redux/modules/modals/modals.module';
import Button from '../../../Shared/Button/Button';

class BucketRollInfo extends Component {
  render() {
    const { closeModal } = this.props;
    return (
      <div>
        <div className="bucket-roll-info-title">
          IRA Contributions Unavailable
        </div>
        <div className="bucket-roll-info-content">
          Sorry, contributions to your IRA(s) are temporarily unavailable due to
          year-end maintenance. Please check back after 7 PM EDT on January 1st
          to make a contribution. If you are attempting to make a purchase into
          Government Money Fund or US Treasury Money Fund prior to 5pm on the
          last business day of the year, please{' '}
          <a href="https://www.troweprice.com/personal-investing/help/contact/index.html">
            contact us
          </a>
          .
        </div>
        <div className="bucket-roll-info-button-container">
          <Button
            buttonType="primary"
            className="bucket-roll-info-button"
            disabled={false}
            id="delete-btn"
            onClick={() => closeModal(BUCKET_ROLL)}
          >
            Close
          </Button>
        </div>
      </div>
    );
  }
}

export default BucketRollInfo;
